module.exports = __webpack_public_path__ + "static/media/galerie.217dfda3.jpg";